import Cookies from 'js-cookie';

// #1 Submit form
(function ($) {
  var $modal = $('.js-project-download-modal');
  var $openBtn = $('.js-project-download-open-modal');
  var $exits = $modal.find('.js-project-download-modal-exit');

  // Hide modal on click "x" icon or "Close" button or clicking outside of modal
  $exits.on('click', function () {
    modal_close();
  });

  var cookieName = 'gfDlSubmitted' + GLOBAL.project_id;

  // Open Project Download Modal after form is successfully submitted
  if ($modal.length > 0) {
    $(document).on('gform_confirmation_loaded', function (event, formId) {
      if (formId == GLOBAL.project_download_form_id) {
        // set cookie which expires in 1 week
        Cookies.set(cookieName, true, { expires: 7 });

        modal_open();

        // show btn so we can open modal again
        $openBtn.removeClass('is-hidden');
      }
    });
  }

  // If form was already submitted, hide form and show open button
  if (Cookies.get(cookieName)) {
    $('.js-project-download-form').remove();
    $openBtn.removeClass('is-hidden');
  }

  $(document).on('click', '.js-project-download-open-modal', function () {
    if (Cookies.get(cookieName)) {
      modal_open();
    }
  });

  function modal_open() {
    $modal.addClass('is-open');
  }

  function modal_close() {
    $modal.removeClass('is-open');
  }
})(jQuery);
